<template>
  <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-blue-900 pt-12 pb-24 sm:pb-32">
    <slot />
  </div>
</template>
